export default __webpack_public_path__ + "static/media/amex.660cff8a.svg";